import type { Catalog } from './en.js';

/**
 * Turkish UI catalog — DRAFT, flagged for Harun's native review in the M1.3
 * PR (same pattern as the P0 word lists). Terminology choices to confirm:
 * "flash" → "gösterim", ORP anchor → "çapa harfi", warm-up → "ısınma".
 */
export const tr: Catalog = {
  'app.name': 'Vif',
  'app.tagline': 'Her zamankinden hızlı oku.',

  'onboarding.intro': 'İdeal okuma hızını yaklaşık 30 saniyede bulalım.',
  'onboarding.getStarted': 'Başla',
  'onboarding.skip': 'Atla — hızımı biliyorum',
  'onboarding.round': 'Tur {round} · {wpm} kelime/dk',
  'onboarding.preparing': 'Hazırlanıyor…',
  'onboarding.howWasThat': 'Nasıldı?',
  'onboarding.tooFast': 'Çok hızlı',
  'onboarding.justRight': 'Tam kararında',
  'onboarding.tooSlow': 'Çok yavaş',
  'onboarding.faster': 'Daha hızlı!',
  'onboarding.yourSpeed': 'Rahat okuma hızın. Ok tuşlarıyla istediğin an değiştirebilirsin.',
  'onboarding.continue': 'Devam',
  'onboarding.tipsTitle': 'Kısa İpuçları',
  'onboarding.tipOrpTitle': 'Çapa Harfi',
  'onboarding.tipOrpBody':
    'Her kelimenin optimal tanıma noktası vurgulanır; gözün hep aynı yerde kalır.',
  'onboarding.tipKeysTitle': 'Klavye Kontrolleri',
  'onboarding.tipKeysBody': 'Boşluk: oynat/duraklat, ↑↓: hız, ←→: cümle cümle gezin.',
  'onboarding.tipWarmupTitle': 'Isınma',
  'onboarding.tipWarmupBody': 'Oturumlar yavaş başlar, hedef hızına doğru yükselir.',
  'onboarding.tipDocsTitle': 'Belgeler',
  'onboarding.tipDocsBody': 'PDF, DOCX, EPUB, TXT/MD bırak — ya da metni doğrudan yapıştır.',
  'onboarding.startReading': 'Okumaya Başla',

  'library.title': 'Kitaplık',
  'library.empty': 'Okumaya başlamak için bir belge içe aktar.',
  'library.import': 'İçe aktar',
  'library.paste': 'Metin yapıştır',
  'library.dropHint': 'PDF · DOCX · EPUB · TXT · MD',
  'library.progress': '%{percent} okundu',
  'library.timeLeft': '{minutes} dk kaldı',
  'library.lastRead': 'Son okuma: {date}',
  'library.never': 'Henüz başlanmadı',
  'library.delete': 'Sil',
  'library.deleteConfirm': '"{title}" silinsin mi ({size})? Okuma konumu ve yer imleri de silinir.',
  'library.sort.recent': 'Son',
  'library.sort.progress': 'İlerleme',
  'library.sort.title': 'Başlık',
  'library.slotCap':
    'Web beta en fazla 5 kitaplık belgesi destekler. Yerel uygulamalar, sınırsız kitaplık için Pro sürümü ekler.',
  'library.slotCapTitle': 'Kitaplık dolu',
  'library.slotsUsed': '{max} yuvanın {used} tanesi dolu',
  'library.legacyResume': 'Eski okuma konumun geri yüklendi.',

  'paste.title': 'Metin yapıştır',
  'paste.placeholder': 'Her şeyi yapıştır — makale, bölüm, not…',
  'paste.start': 'Okumaya Başla',
  'paste.documentTitle': 'Yapıştırılan metin',

  'import.parsing': '"{name}" hazırlanıyor…',
  'import.page': 'Sayfa {page} / {total}',
  'import.cancel': 'İptal',
  'import.duplicate': 'Zaten kitaplığında — açılıyor.',
  'import.failed': 'İçe aktarma başarısız',

  'reader.resume': '{word}. kelimeden devam edilsin mi?',
  'reader.resumeYes': 'Devam et',
  'reader.resumeNo': 'Baştan başla',
  'reader.finished': 'Bitti',
  'reader.wpm': 'kelime/dk',
  'reader.chapter': 'Bölüm',
  'reader.contents': 'İçindekiler',
  'reader.bookmarks': 'Yer imleri',
  'reader.bookmarkAdded': 'Yer imi eklendi',
  'reader.timeLeft': '{minutes} dk',
  'reader.back': 'Kitaplık',
  'reader.playPause': 'Oynat veya duraklat',
  'reader.seek': 'Okuma konumu',
  'reader.rsvpLabel': 'Hızlı ardışık kelime gösterimi — okuma hızında tek tek kelimeler',

  'settings.title': 'Ayarlar',
  'settings.theme': 'Tema',
  'settings.theme.dark': 'Koyu',
  'settings.theme.light': 'Açık',
  'settings.theme.amoled': 'AMOLED',
  'settings.fontSize': 'Kelime boyutu',
  'settings.font': 'Okuma yazı tipi',
  'settings.font.mono': 'JetBrains Mono',
  'settings.font.plex': 'Vif Neue',
  'settings.font.code': 'Vif Code',
  'settings.font.dyslexic': 'Vif Dyslexic',
  'settings.fontNote': 'Disleksi dostu yazı tipi deneyseldir; çapa ≤1 px kayabilir.',
  'settings.fontDerivation':
    'Vif Neue, IBM Plex Mono; Vif Code, Source Code Pro; Vif Dyslexic, OpenDyslexic türevidir (lisansları gereği yeniden adlandırıldı).',
  'reader.quickSettings': 'Hızlı ayarlar',
  'settings.orpColor': 'Çapa rengi',
  'settings.showGuides': 'Kılavuz çentikleri',
  'settings.targetWpm': 'Okuma hızı',
  'settings.recalibrate': 'Yeniden kalibre et',
  'settings.adaptive': 'Uyarlanabilir kelime süresi',
  'settings.warmup': 'Isınma',
  'settings.warmupDuration': 'Isınma süresi',
  'settings.warmupStart': 'Isınma başlangıç hızı',
  'settings.chunk': 'Gösterim başına kelime',
  'settings.chunkLayout': 'Grup düzeni',
  'settings.chunkLayout.vertical': 'Alt alta',
  'settings.chunkLayout.horizontal': 'Yan yana',
  'settings.appLanguage': 'Uygulama dili',
  'settings.docLanguage': 'Belge dili',
  'settings.docLanguage.auto': 'Otomatik ({detected})',
  'settings.stats': 'İstatistikler',
  'settings.stats.session': 'Bu oturum',
  'settings.stats.words': 'Kelime',
  'settings.stats.time': 'Süre',
  'settings.stats.avgWpm': 'Ort. kelime/dk',
  'settings.stats.total': 'Tüm zamanlar',
  'settings.stats.sessions': 'Oturum',
  'settings.backup': 'Yedekleme',
  'settings.export': 'Kitaplığı dışa aktar (.vif)',
  'settings.import': 'Yedek içe aktar…',
  'settings.importConfirm':
    'Yedek içe aktarmak tüm kitaplığını, konumlarını ve ayarlarını değiştirir. Devam edilsin mi?',
  'settings.importDone': 'Yedek geri yüklendi.',
  'settings.seconds': '{n} sn',

  'durability.banner':
    'Kitaplığın bu tarayıcının deposunda durur ve alan azalırsa tarayıcı tarafından silinebilir. Yedeğin, dışa aktardığın dosyadır.',
  'durability.install': "Vif'i yükle",
  'durability.export': 'Şimdi dışa aktar',

  'common.cancel': 'İptal',
  'common.ok': 'Tamam',
  'common.close': 'Kapat',
  'common.on': 'Açık',
  'common.off': 'Kapalı',
};
